export default "__VITE_ASSET__Dr_QHJw4__"